import axios from 'axios'
import qs from 'qs'
import Axios from 'axios';

axios.defaults.baseURL = host_url;
axios.interceptors.request.use((request) => {


    if (!request.data) {
        request.data = {};
    }
    let token = localStorage.getItem("$$token")
    if (token) {
        request.headers.Authorization = token;
    }
    return request
});

axios.interceptors.response.use((res) => {

    return res;
})

export default {
    setHostUrl(url) {
        axios.defaults.baseURL = url;
    },
    getAppUrl() {
        return axios.get(api_url)
    },

    getConfig() {
        return axios.get("/api/config")
    },
    getServerTime() {
        return axios.get('/api/servertime')
    },

    register(phone, password, vcode, name, icode, idnumber) {
        return axios.post("/api/register", {
            phone: phone,
            password: password,
            vcode: vcode,
            name: name,
            
            icode: icode,
            idnumber: idnumber,
            domain: window.location.origin,
        })
    },

    login(phone, password) {
        return axios.post("/api/login", {
            phone: phone,
            password: password
        });
    },
    loginByUserName(username,password) {
        return axios.post("/api/loginByUserName", {
            username: username,
            password: password
        });
    },

    getOpenInfo(code) {
        return axios.get("/api/opencode/" + code + "/100")
    },
    getUserInfo() {
        return axios.get("/api/userinfo")
    },
    getBetTypes() {
        return axios.get("/api/bettypelist")
    },
    batchbet(data) {
        return axios.post("/api/batchbet", data);
    },
    bet(data) {
        console.log(data);
        return axios.post("/api/bet", data);
    },
    updateAvatar(data) {
        return axios.post("/api/updateAvatar", data)
    },
    recharge(value, payway) {
        return axios.post("/api/recharge", {
            value: value,
            payway: payway
        })
    },
    addbank(bankinfo) {
        return axios.post("/api/addbank", bankinfo);
    },
    wallet(wallet) {
          return axios.post("/api/addwallet", wallet);
    },

    resetpass(password1) {
        return axios.post("/api/resetpass", { password: password1 })
    },
    setpass1(password1) {
        return axios.post("/api/setpass1", { password: password1 })
    },
    tixian(obj) {
        return axios.post("/api/tixian", obj)
    },
    getRechargeRecord() {
        return axios.get("/api/recharge_record")
    },
    getTiXianRecord() {
        return axios.get("/api/tixian_record")
    },
    getNews() {
        return axios.get("/api/news");
    },
    getOpenList(gamecode) {
        return axios.get("/api/opening_records/" + gamecode + "/1")
    },
    getBetRecords(tp, starttime, endtime, done, page) {
        return axios.get("/api/bet_records/" + tp + "/" + starttime + "/" + endtime + "/" + done + "/" + page)
    },
    getDataFromUrl(url) {
        return axios.get(url)
    },
    getBookChapters(bookid) {
        return axios.get('/api/bookchapters?where={"bookid":' + bookid + '}')
    },
    getChapterDetail(cid) {
        return axios.get('/api/chapter/' + cid)
    },
    getTestData(period, symbol, size) {

        return axios.get("/api/market/kline?period=" + period + "&size=" + size + "&symbol=" + symbol)
    },
    getSymbolData(period, symbol, size) {
        return axios.get("/api/url/https://api.huobipro.com/market/history/kline?period=" + period + "&size=" + size + "&symbol=" + symbol)
    },
    getTickers() {
        return axios.get("/api/market/tickers")
    },
    getVcode(phone) {
        return axios.get("/api/getsms/" + phone)
    },
    isReg(phone) {
        return axios.post('/api/isreg/' + phone)
    },
    buy(data) {
        return axios.post('/api/buy', data)
    },
    auth(data) {
        return axios.post("/api/auth1",data)
    },
    sell(data) {
        return axios.post("/api/sell", data)
    },
    transactions() {
        return axios.get("/api/transactions")
    },
    getPrice(code) {
        return axios.get("/api/getprice/" + code)
    },
    getGameResult(expect) {
        return axios.get("/api/gameResult/" + expect)
    },
    getWinData() {
        return axios.get("/api/win")
    },
    getProlist() {
        return axios.get("/api/products")
    }
}


// WEBPACK FOOTER //
// ./src/api.js